'use strict';

var _defineProperty = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncGeneratorDelegate = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var log = require('debug')('ipfs:mfs:write');

var importer = require('ipfs-unixfs-importer');

var stat = require('./stat');

var mkdir = require('./mkdir');

var addLink = require('./utils/add-link');

var applyDefaultOptions = require('./utils/apply-default-options');

var createLock = require('./utils/create-lock');

var toAsyncIterator = require('./utils/to-async-iterator');

var toMfsPath = require('./utils/to-mfs-path');

var toPathComponents = require('./utils/to-path-components');

var toTrail = require('./utils/to-trail');

var updateTree = require('./utils/update-tree');

var updateMfsRoot = require('./utils/update-mfs-root');

var errCode = require('err-code');

var _require = require('../../utils'),
    MFS_MAX_CHUNK_SIZE = _require.MFS_MAX_CHUNK_SIZE;

var last = require('it-last');

var defaultOptions = {
  offset: 0,
  // the offset in the file to begin writing
  length: undefined,
  // how many bytes from the incoming buffer to write
  create: false,
  // whether to create the file if it does not exist
  truncate: false,
  // whether to truncate the file first
  rawLeaves: false,
  reduceSingleLeafToSelf: false,
  cidVersion: 0,
  hashAlg: 'sha2-256',
  parents: false,
  // whether to create intermediate directories if they do not exist
  progress: function progress() {},
  strategy: 'trickle',
  flush: true,
  leafType: 'raw',
  shardSplitThreshold: 1000,
  mode: undefined,
  mtime: undefined
};

module.exports = function (context) {
  return /*#__PURE__*/function () {
    var _mfsWrite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, content, options) {
      var source, destination, parent;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = applyDefaultOptions(options, defaultOptions);
              log('Reading source, destination and parent');
              _context2.next = 4;
              return createLock().readLock( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return toAsyncIterator(content, options);

                      case 2:
                        source = _context.sent;
                        _context.next = 5;
                        return toMfsPath(context, path);

                      case 5:
                        destination = _context.sent;
                        _context.next = 8;
                        return toMfsPath(context, destination.mfsDirectory);

                      case 8:
                        parent = _context.sent;

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })))();

            case 4:
              log('Read source, destination and parent');

              if (!(!options.parents && !parent.exists)) {
                _context2.next = 7;
                break;
              }

              throw errCode(new Error('directory does not exist'), 'ERR_NO_EXIST');

            case 7:
              if (!(!options.create && !destination.exists)) {
                _context2.next = 9;
                break;
              }

              throw errCode(new Error('file does not exist'), 'ERR_NO_EXIST');

            case 9:
              return _context2.abrupt("return", updateOrImport(context, path, source, destination, options));

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function mfsWrite(_x4, _x5, _x6) {
      return _mfsWrite.apply(this, arguments);
    }

    return mfsWrite;
  }();
};

var updateOrImport = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, path, source, destination, options) {
    var child;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return write(context, source, destination, options);

          case 2:
            child = _context4.sent;
            _context4.next = 5;
            return createLock().writeLock( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var pathComponents, fileName, parentExists, updatedPath, trail, parent, parentNode, result, newRootCid;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      pathComponents = toPathComponents(path);
                      fileName = pathComponents.pop();
                      parentExists = false;
                      _context3.prev = 3;
                      _context3.next = 6;
                      return stat(context)("/".concat(pathComponents.join('/')), options);

                    case 6:
                      parentExists = true;
                      _context3.next = 13;
                      break;

                    case 9:
                      _context3.prev = 9;
                      _context3.t0 = _context3["catch"](3);

                      if (!(_context3.t0.code !== 'ERR_NOT_FOUND')) {
                        _context3.next = 13;
                        break;
                      }

                      throw _context3.t0;

                    case 13:
                      if (parentExists) {
                        _context3.next = 16;
                        break;
                      }

                      _context3.next = 16;
                      return mkdir(context)("/".concat(pathComponents.join('/')), options);

                    case 16:
                      _context3.next = 18;
                      return toMfsPath(context, path);

                    case 18:
                      updatedPath = _context3.sent;
                      _context3.next = 21;
                      return toTrail(context, updatedPath.mfsDirectory, options);

                    case 21:
                      trail = _context3.sent;
                      parent = trail[trail.length - 1];

                      if (parent.type.includes('directory')) {
                        _context3.next = 25;
                        break;
                      }

                      throw errCode(new Error("cannot write to ".concat(parent.name, ": Not a directory")), 'ERR_NOT_A_DIRECTORY');

                    case 25:
                      _context3.next = 27;
                      return context.ipld.get(parent.cid);

                    case 27:
                      parentNode = _context3.sent;
                      _context3.next = 30;
                      return addLink(context, {
                        parent: parentNode,
                        name: fileName,
                        cid: child.cid,
                        size: child.size,
                        flush: options.flush,
                        shardSplitThreshold: options.shardSplitThreshold,
                        hashAlg: options.hashAlg,
                        cidVersion: options.cidVersion
                      });

                    case 30:
                      result = _context3.sent;
                      parent.cid = result.cid; // update the tree with the new child

                      _context3.next = 34;
                      return updateTree(context, trail, options);

                    case 34:
                      newRootCid = _context3.sent;
                      _context3.next = 37;
                      return updateMfsRoot(context, newRootCid);

                    case 37:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, null, [[3, 9]]);
            })))();

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function updateOrImport(_x7, _x8, _x9, _x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();

var write = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(context, source, destination, options) {
    var sources, extra, content, mode, mtime, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (destination.exists) {
              log("Overwriting file ".concat(destination.cid, " offset ").concat(options.offset, " length ").concat(options.length));
            } else {
              log("Writing file offset ".concat(options.offset, " length ").concat(options.length));
            }

            sources = []; // pad start of file if necessary

            if (options.offset > 0) {
              if (destination.unixfs) {
                log("Writing first ".concat(options.offset, " bytes of original file"));
                sources.push(function () {
                  return destination.content({
                    offset: 0,
                    length: options.offset
                  });
                });

                if (destination.unixfs.fileSize() < options.offset) {
                  extra = options.offset - destination.unixfs.fileSize();
                  log("Writing zeros for extra ".concat(extra, " bytes"));
                  sources.push(asyncZeroes(extra));
                }
              } else {
                log("Writing zeros for first ".concat(options.offset, " bytes"));
                sources.push(asyncZeroes(options.offset));
              }
            }

            sources.push(limitAsyncStreamBytes(source, options.length));
            content = countBytesStreamed(catAsyncIterators(sources), function (bytesWritten) {
              if (destination.unixfs && !options.truncate) {
                // if we've done reading from the new source and we are not going
                // to truncate the file, add the end of the existing file to the output
                var fileSize = destination.unixfs.fileSize();

                if (fileSize > bytesWritten) {
                  log("Writing last ".concat(fileSize - bytesWritten, " of ").concat(fileSize, " bytes from original file starting at offset ").concat(bytesWritten));
                  return destination.content({
                    offset: bytesWritten
                  });
                } else {
                  log('Not writing last bytes from original file');
                }
              }

              return _defineProperty({}, Symbol.asyncIterator, _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              })));
            });

            if (options.mode !== undefined && options.mode !== null) {
              mode = options.mode;
            } else if (destination && destination.unixfs) {
              mode = destination.unixfs.mode;
            }

            if (options.mtime !== undefined && options.mtine !== null) {
              mtime = options.mtime;
            } else if (destination && destination.unixfs) {
              mtime = destination.unixfs.mtime;
            }

            _context6.next = 9;
            return last(importer([{
              content: content,
              // persist mode & mtime if set previously
              mode: mode,
              mtime: mtime
            }], context.block, {
              progress: options.progress,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion,
              strategy: options.strategy,
              rawLeaves: options.rawLeaves,
              reduceSingleLeafToSelf: options.reduceSingleLeafToSelf,
              leafType: options.leafType,
              pin: false
            }));

          case 9:
            result = _context6.sent;
            log("Wrote ".concat(result.cid));
            return _context6.abrupt("return", {
              cid: result.cid,
              size: result.size
            });

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function write(_x12, _x13, _x14, _x15) {
    return _ref7.apply(this, arguments);
  };
}();

var limitAsyncStreamBytes = function limitAsyncStreamBytes(stream, limit) {
  return /*#__PURE__*/function () {
    var _limitAsyncStreamBytes2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var emitted, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, buf;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              emitted = 0;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context7.prev = 3;
              _iterator = _asyncIterator(stream);

            case 5:
              _context7.next = 7;
              return _awaitAsyncGenerator(_iterator.next());

            case 7:
              _step = _context7.sent;
              _iteratorNormalCompletion = _step.done;
              _context7.next = 11;
              return _awaitAsyncGenerator(_step.value);

            case 11:
              _value = _context7.sent;

              if (_iteratorNormalCompletion) {
                _context7.next = 24;
                break;
              }

              buf = _value;
              emitted += buf.length;

              if (!(emitted > limit)) {
                _context7.next = 19;
                break;
              }

              _context7.next = 18;
              return buf.slice(0, limit - emitted);

            case 18:
              return _context7.abrupt("return");

            case 19:
              _context7.next = 21;
              return buf;

            case 21:
              _iteratorNormalCompletion = true;
              _context7.next = 5;
              break;

            case 24:
              _context7.next = 30;
              break;

            case 26:
              _context7.prev = 26;
              _context7.t0 = _context7["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context7.t0;

            case 30:
              _context7.prev = 30;
              _context7.prev = 31;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context7.next = 35;
                break;
              }

              _context7.next = 35;
              return _awaitAsyncGenerator(_iterator.return());

            case 35:
              _context7.prev = 35;

              if (!_didIteratorError) {
                _context7.next = 38;
                break;
              }

              throw _iteratorError;

            case 38:
              return _context7.finish(35);

            case 39:
              return _context7.finish(30);

            case 40:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[3, 26, 30, 40], [31,, 35, 39]]);
    }));

    function _limitAsyncStreamBytes() {
      return _limitAsyncStreamBytes2.apply(this, arguments);
    }

    return _limitAsyncStreamBytes;
  }();
};

var asyncZeroes = function asyncZeroes(count) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MFS_MAX_CHUNK_SIZE;
  var buf = Buffer.alloc(chunkSize, 0);

  var stream = _defineProperty({}, Symbol.asyncIterator, /*#__PURE__*/_regeneratorRuntime.mark(function _asyncZeroes() {
    return _regeneratorRuntime.wrap(function _asyncZeroes$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!true) {
              _context8.next = 5;
              break;
            }

            _context8.next = 3;
            return buf.slice();

          case 3:
            _context8.next = 0;
            break;

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _asyncZeroes);
  }));

  return limitAsyncStreamBytes(stream, count);
};

var catAsyncIterators = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(sources) {
    var i;
    return _regeneratorRuntime.wrap(function _callee8$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < sources.length)) {
              _context9.next = 6;
              break;
            }

            return _context9.delegateYield(_asyncGeneratorDelegate(_asyncIterator(sources[i]()), _awaitAsyncGenerator), "t0", 3);

          case 3:
            i++;
            _context9.next = 1;
            break;

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee8);
  }));

  return function catAsyncIterators(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var countBytesStreamed = /*#__PURE__*/function () {
  var _ref3 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(source, notify) {
    var wrote, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, buf, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, _buf;

    return _regeneratorRuntime.wrap(function _callee9$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            wrote = 0;
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context10.prev = 3;
            _iterator2 = _asyncIterator(source);

          case 5:
            _context10.next = 7;
            return _awaitAsyncGenerator(_iterator2.next());

          case 7:
            _step2 = _context10.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context10.next = 11;
            return _awaitAsyncGenerator(_step2.value);

          case 11:
            _value2 = _context10.sent;

            if (_iteratorNormalCompletion2) {
              _context10.next = 20;
              break;
            }

            buf = _value2;
            wrote += buf.length;
            _context10.next = 17;
            return buf;

          case 17:
            _iteratorNormalCompletion2 = true;
            _context10.next = 5;
            break;

          case 20:
            _context10.next = 26;
            break;

          case 22:
            _context10.prev = 22;
            _context10.t0 = _context10["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context10.t0;

          case 26:
            _context10.prev = 26;
            _context10.prev = 27;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context10.next = 31;
              break;
            }

            _context10.next = 31;
            return _awaitAsyncGenerator(_iterator2.return());

          case 31:
            _context10.prev = 31;

            if (!_didIteratorError2) {
              _context10.next = 34;
              break;
            }

            throw _iteratorError2;

          case 34:
            return _context10.finish(31);

          case 35:
            return _context10.finish(26);

          case 36:
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _context10.prev = 38;
            _iterator3 = _asyncIterator(notify(wrote));

          case 40:
            _context10.next = 42;
            return _awaitAsyncGenerator(_iterator3.next());

          case 42:
            _step3 = _context10.sent;
            _iteratorNormalCompletion3 = _step3.done;
            _context10.next = 46;
            return _awaitAsyncGenerator(_step3.value);

          case 46:
            _value3 = _context10.sent;

            if (_iteratorNormalCompletion3) {
              _context10.next = 55;
              break;
            }

            _buf = _value3;
            wrote += _buf.length;
            _context10.next = 52;
            return _buf;

          case 52:
            _iteratorNormalCompletion3 = true;
            _context10.next = 40;
            break;

          case 55:
            _context10.next = 61;
            break;

          case 57:
            _context10.prev = 57;
            _context10.t1 = _context10["catch"](38);
            _didIteratorError3 = true;
            _iteratorError3 = _context10.t1;

          case 61:
            _context10.prev = 61;
            _context10.prev = 62;

            if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
              _context10.next = 66;
              break;
            }

            _context10.next = 66;
            return _awaitAsyncGenerator(_iterator3.return());

          case 66:
            _context10.prev = 66;

            if (!_didIteratorError3) {
              _context10.next = 69;
              break;
            }

            throw _iteratorError3;

          case 69:
            return _context10.finish(66);

          case 70:
            return _context10.finish(61);

          case 71:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee9, null, [[3, 22, 26, 36], [27,, 31, 35], [38, 57, 61, 71], [62,, 66, 70]]);
  }));

  return function countBytesStreamed(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();